export default "__VITE_ASSET__C_mFBA1x__"